import {
  useActivateMilestonesMutation,
  useLazyGetMilestoneGanttChartDataQuery,
  useLazyGetMilestoneTrackingDataQuery,
  useUpdateMilestoneDataStatusMutation
} from 'src/services/MilestoneTracking';

export const useMilestoneTracking = () => {
  const [
    getMilestoneQueryData,
    { data: milestoneData, error: milestoneDataError, isError: milestoneDataIsError, isLoading: milestoneDataLoading }
  ] = useLazyGetMilestoneTrackingDataQuery();

  const [
    updateMilestoneDataStatus,
    {
      isLoading: updateMilestoneLoading,
      isSuccess: updateMilestoneSuccess,
      data: updateMilestoneData,
      isError: updateMilestoneIsError,
      error: updateMilestoneError
    }
  ] = useUpdateMilestoneDataStatusMutation();

  const [
    getMilestoneGanttLazyData,
    {
      data: milestoneGanttData,
      error: milestoneGanttDataError,
      isError: milestoneGanttDataIsError,
      isLoading: milestoneGanttDataLoading
    }
  ] = useLazyGetMilestoneGanttChartDataQuery();

  const [
    activateMilestone,
    {
      isLoading: activateMilestoneLoading,
      isSuccess: activateMilestoneSuccess,
      data: activateMilestoneData,
      isError: activateMilestoneIsError,
      error: activateMilestoneError
    }
  ] = useActivateMilestonesMutation();

  return {
    milestoneData,
    milestoneDataError,
    milestoneDataIsError,
    milestoneDataLoading,
    getMilestoneQueryData,
    updateMilestoneLoading,
    updateMilestoneSuccess,
    updateMilestoneData,
    updateMilestoneError,
    updateMilestoneIsError,
    updateMilestoneDataStatus,
    milestoneGanttData,
    milestoneGanttDataError,
    milestoneGanttDataIsError,
    milestoneGanttDataLoading,
    getMilestoneGanttLazyData,
    activateMilestone,
    activateMilestoneLoading,
    activateMilestoneSuccess,
    activateMilestoneData,
    activateMilestoneIsError,
    activateMilestoneError
  };
};
